import { API_BASE } from "@/lib/api";
import { toast } from "sonner";
import { Download } from "lucide-react";

export default function ExportButton({ path, filename, label = "Export Excel", testId }) {
  const onClick = async () => {
    const token = localStorage.getItem("phc_token");
    try {
      const res = await fetch(`${API_BASE}${path}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("bad status " + res.status);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Downloaded");
    } catch (e) {
      toast.error("Export failed");
    }
  };
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className="inline-flex items-center gap-2 border border-slate-200 bg-white text-slate-800 text-xs font-semibold px-3 py-2 rounded-md hover:bg-slate-50 transition-colors duration-150"
    >
      <Download className="h-3.5 w-3.5" /> {label}
    </button>
  );
}
